import { AuthInfoContext } from './AuthContextProvider';
import { getUserPermission } from './apicalls/employeeMaster';
import React, {
  useState,
  ReactNode,
  useContext,
  useCallback,
  useEffect
} from 'react';
import { useSetRecoilState } from 'recoil';
import { isLoggedIn } from './GlobalState';
import { Redirect, useLocation } from 'react-router-dom';
import { SITE_MANGE_PLAN_ACCESS_ALLOW } from './const/Const';

type Props = {
  children: ReactNode;
};

export const AuthGuardSiteManagePlan: React.VFC<Props> = props => {
  const { children } = props;
  const location = useLocation();
  const [errorMessage, setErrorMessage] = useState('');
  const [loading, setLoading] = useState(true);
  const [authInfo, setAuthInfo] = useContext(AuthInfoContext);

  const setLoggedIn = useSetRecoilState(isLoggedIn);
  const changeLoggedInData = useCallback(
    (newData: string) => setLoggedIn(newData),
    [setLoggedIn]
  );

  // URL直打ちで表示できるようにするため、ログイン情報を取得し直す
  useEffect(() => {
    getUserRole();
  }, []);

  const getUserRole = useCallback(() => {
    getUserPermission().then(data => {
      if (data === 'Not logged in!') {
        changeLoggedInData('Not logged in!');
        setAuthInfo(undefined);
      } else {
        if (typeof data !== 'string' && !data.error) {
          setAuthInfo(data);
        }
      }
      setLoading(false);
    });
  }, [changeLoggedInData]);

  // NOTE: メニュー出し分けリリースまでの暫定対応
  return authInfo && authInfo.site_manage_plan_id != 99 ? (
    // ユーザー情報があり、アクセス権限がある場合画面表示
    <>{children}</>
  ) : loading ? (
    // ユーザー情報取得中は待機
    <></>
  ) : (
    // ユーザー情報取得が取得できない、またはアクセス権限がない場合はリダイレクト
    <Redirect
      to={{
        pathname: '/',
        state: { from: location }
      }}
    />
  );
};
